<template>
  <div class="container">
    <!--Cargando nodos del chatbot-->
    <div v-if="loading" class="container--loading display-flex direction-column align--center">
      <a-spin />
      <p class="mrg-top-12">Cargando datos</p>
    </div>
    <!--Si ya termino de cargar-->
    <template v-else>
      <!--Si existe el arbol de nodos-->
      <tree
        v-if="treeNodes"
        :nodeList="treeNodes"
        :parent="null"
        :key="count"
        :currentChannel="currentChannel"
        @onOpenDrawer="handleOpenDrawer"
        @preview="handlePreview"
        :disabled-actions="disabledActions"
        @onPreviewMedia="handleShowPreviewMedia"
      />
      <!--Si no existe el arbol de nodos-->
      <div v-else class="container--loading display-flex direction-column align--center">
        <p class="mrg-top-12">Este chatbot aún no tiene un flujo</p>
      </div>
      <modal-preview-media v-bind="modalPreviewMedia" @onClose="handleClosePreviewMedia" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { debounce } from "lodash";
import Tree from "@/app/chatbots/components/tree/Tree.vue";
import ModalPreviewMedia from "@/app/chatbots/components/modals/ModalPreviewMedia.vue";
import { Multimedia } from "@/@types/chatbots/multimedia";

export default {
  name: "ContainerTree",
  props: {
    chatbotId: { type: [Number, String], required: true }, // String, cuando viende de los parametros de la ruta
    disabledActions: {
      type: Boolean,
      default: false,
    },
    currentChannel: { type: Object, default: () => ({}) },
  },
  components: {
    Tree,
    ModalPreviewMedia,
  },
  data: () => ({
    count: 0,
    loading: true,
    debounce,
    modalPreviewMedia: {
      visible: false,
      title: "",
      type: "",
      url: "",
    },
  }),
  mounted() {
    this.$nextTick(() => {
      // si el id del chatbot existe y si aun no hay nodos
      if (this.chatbotId && !this.nodes.length) this.loadNodes(this.chatbotId);
      else this.loading = false;
    });
  },
  beforeUnmount() {
    // antes de destruirse el componente resetea
    this.handleReset();
  },
  watch: {
    chatbotId(value) {
      // si el id del chatbot existe y si aun no hay nodos
      if (value && !this.nodes && !this.nodes.length) this.loadNodes(this.value);
      else this.loading = false;
    },
    nodes: {
      deep: true,
      handler: function () {
        this.$nextTick(() => this.count++);
      },
    },
  },
  computed: {
    ...mapGetters(["nodes", "company"]),
    treeNodes() {
      return this.$store.getters["getChatbotNodes"];
    },
  },
  methods: {
    ...mapActions(["resetTreeNodes", "getNodes", "resetNodes"]),

    loadNodes() {
      this.loading = false;
    },
    /**
     * Emitir evento para abrir el drawer
     * @param {Object} settings
     * @param {Object} settings.drawer - para nodos principales: mensaje u opciones
     * @param {Object} settings.drawer.question
     * @param {String} settings.drawer.question.type
     * @param {String} settings.drawer.action.message
     * @param {String} settings.drawer.action.lineId
     * @param {Boolean} settings.drawer.action.withMessage
     * @param {Object} settings.action - para opciones
     * @param {String} settings.action.nodeType
     * @param {String} settings.action.type
     * @param {String} settings.action.message
     * @param {String} settings.action.lineId
     * @param {Boolean} settings.action.withMessage
     */
    handleOpenDrawer(settings) {
      this.$emit("onOpenDrawer", settings);
    },
    /**
     * Resetea los nodos y el arbol de nodos
     */
    handleReset() {
      this.resetTreeNodes();
      this.resetNodes();
    },
    handlePreview(imageUrl) {
      console.log(imageUrl);
      this.$emit("preview", imageUrl);
    },
    handleShowPreviewMedia(media) {
      if (!media) return;
      // si es de tipo archivo descargará
      if (media.type === Multimedia.Document) return window.open(media.url);
      this.modalPreviewMedia.type = media.type || "";
      this.modalPreviewMedia.title = media.name;
      this.modalPreviewMedia.url = media.url || "";
      this.modalPreviewMedia.visible = true;
    },
    handleClosePreviewMedia() {
      this.modalPreviewMedia.visible = false;
      this.modalPreviewMedia.title = "";
      this.modalPreviewMedia.type = "";
      this.modalPreviewMedia.url = "";
    },
  },
};
</script>

<style lang="sass" scoped>
.container
  width: 100%
  &--loading
    margin: 40px
    color: $gray_6
</style>
